import CryptoJS from 'crypto-js';
// import heic2any from 'heic2any';
import { config } from './utils';

const decryptString = (value: string) => {
  let decryptedString = '';
  const dataString = value
    .replace(/p1L2u3S/g, '+')
    .replace(/s1L2a3S4h/g, '/')
    .replace(/e1Q2u3A4l/g, '=');
  try {
    decryptedString = CryptoJS.AES.decrypt(
      dataString,
      config.SECRET_KEY
    ).toString(CryptoJS.enc.Utf8);
  } catch (error) { }
  return decryptedString;
};

const encryptString = (value: string) => {
  const ciphertext = CryptoJS.AES.encrypt(
    String(value),
    config.SECRET_KEY
  ).toString();
  return ciphertext
    .replace(/\+/g, 'p1L2u3S')
    .replace(/\//g, 's1L2a3S4h')
    .replace(/=/g, 'e1Q2u3A4l');
};

const getStoredAccessToken = () => {
  const raw = localStorage.getItem(config.AUTH_KEY);
  if (!raw) return '';

  try {
    const parsed = JSON.parse(raw);
    if (typeof parsed?.accessToken === 'string') {
      return parsed.accessToken;
    }
  } catch {
    // Stored as a plain JWT string.
  }

  return raw;
};

const normalizeAssetKey = (key: string) => String(key).replace(/^\//, '');

const getProxyAssetUrl = (key: string) => {
  const normalizedKey = normalizeAssetKey(key);
  const params = new URLSearchParams({ key: normalizedKey });
  const token = getStoredAccessToken();

  if (token) {
    params.set('authToken', token);
  }

  return new URL(
    `upload-asset/file?${params.toString()}`,
    config.BASE_URL
  ).href;
};

const getAssetURl = (key?: string | null, prodUrl?: string) => {
  if (!key) {
    return '';
  }

  if (
    key.startsWith('http://') ||
    key.startsWith('https://') ||
    key.startsWith('data:') ||
    key.startsWith('blob:')
  ) {
    return key;
  }

  const normalizedKey = normalizeAssetKey(key);
  const baseUrl = prodUrl?.trim() || config.ASSET_URL;

  if (baseUrl) {
    return `${baseUrl.replace(/\/$/, '')}/${normalizedKey}`;
  }

  return getProxyAssetUrl(normalizedKey);
};

const resolveAssetUrl = (keyOrUrl?: string | null, prodUrl?: string) => {
  if (!keyOrUrl) return '';

  if (
    keyOrUrl.startsWith('http://') ||
    keyOrUrl.startsWith('https://') ||
    keyOrUrl.startsWith('data:') ||
    keyOrUrl.startsWith('blob:')
  ) {
    return keyOrUrl;
  }

  return getAssetURl(keyOrUrl, prodUrl);
};

export {
  encryptString,
  decryptString,
  getAssetURl,
  getProxyAssetUrl,
  resolveAssetUrl,
};
